import React from 'react';
import { IconProps } from './types/Icon.type';

function EmptyIcon(props: IconProps) {
  return (
    <svg
      width={props.boxSize ?? '56'}
      height={props.boxSize ?? '56'}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 54C42.3594 54 54 42.3594 54 28C54 13.6406 42.3594 2 28 2C13.6406 2 2 13.6406 2 28C2 42.3594 13.6406 54 28 54ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
        fill={props.fill ?? '#121212'}
      />
      <path
        d="M29.2963 36.1498C29.3216 35.245 28.5602 34.4998 27.6212 34.4998C26.7329 34.4998 25.9969 35.245 25.9969 36.1498C25.9969 37.0546 26.7329 37.7998 27.6212 37.7998C28.5602 37.7998 29.3216 37.0546 29.2963 36.1498Z"
        fill={props.fill ?? '#121212'}
      />
      <path
        d="M25.9969 18.0001L29.2969 17.9998L28.7469 32.2998L26.5469 32.2998L25.9969 18.0001Z"
        fill={props.fill ?? '#121212'}
      />
    </svg>
  );
}

export default EmptyIcon;
